import { type GitInfo } from 'git-describe';


export const gitInfoPartial: Partial<GitInfo> = {"dirty":false,"hash":"af46920"};
